






















import Vue from 'vue';
import {Component} from "vue-property-decorator";
import Modal from "./Modal.vue";

@Component({
  components: {
    Modal
  }
})
export default class DelayRepayWhichOperator extends Vue {
  open: boolean = true;

}
